import React from 'react'
import { Link } from 'react-router-dom'
import './styles.css'
import DropDownMenu from 'material-ui/DropDownMenu';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import FlatButton from 'material-ui/FlatButton';

const SessionHeader = ({ title, titleColor, textSeemore, lineSeemore, dropdown, list = [], onClick, textAllFillter, hiddenSeemore = false }) => (
  <div className="sessionHeader">
    <h3 className="textHeader" style={{ color: titleColor }}>{title}</h3>
    {!hiddenSeemore && (
      !dropdown ?
      <Link to={lineSeemore}>
          {textSeemore}
          <i className="material-icons">keyboard_arrow_right</i>
        </Link> :
      <div className='wrappButtonFilter'>
        {dropdown && (   
          <IconMenu
          // iconButtonElement={<IconButton><p to={lineSeemore}>{textSeemore}<i className="material-icons">keyboard_arrow_down</i></p></IconButton>}
          iconButtonElement={
            <FlatButton
              label={textSeemore}
              labelPosition="before"
              primary={true}
              icon={<i className="material-icons">keyboard_arrow_down</i>}
            />

          }
          anchorOrigin={{horizontal: 'right', vertical: 'top'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
        >
          <MenuItem value={0} primaryText={textAllFillter} onClick={() => onClick(0)} />
          {
            list.map((value, i) => (
              <MenuItem value={i+1} primaryText={value.title} onClick={() => onClick(value.id)} />
            ))
          }
        </IconMenu>
        )}
      </div>
    )}
  </div>
)
SessionHeader.defaultProps = {
  title: '',
  SessionHeader: '',
  lineSeemore: '/seemore/popularNews'
}

export default SessionHeader



// WEBPACK FOOTER //
// ./src/components/SessionHeader/SessionHeader.js